import { render, staticRenderFns } from "./amostras.vue?vue&type=template&id=45b61f16&"
import script from "./amostras.vue?vue&type=script&lang=js&"
export * from "./amostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports